import React from 'react';

interface AddAccountTypeProps {
  onManualClick: () => void;
  onLinkClick: () => void;
  isPremium?: boolean;
}

const AddAccountType: React.FC<AddAccountTypeProps> = ({
  onManualClick,
  onLinkClick,
  isPremium = false,
}) => {
  return (
    <div className="space-y-6">
      <p className="text-sm text-gray-600">
        Choose how you want to add your account. Manual entry is available now; E*Trade linking is available for premium testers.
      </p>
      
      <div className="grid grid-cols-1 gap-4">
        {/* Manual Account Button */}
        <button
          onClick={onManualClick}
          className="flex flex-col items-center justify-center p-6 border border-gray-300 rounded-lg text-center hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 space-y-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          <span className="font-medium text-gray-700">Manually add investments</span>
        </button>

        {/* Link Account Button */}
        <button
          onClick={onLinkClick}
          disabled={!isPremium}
          className={
            isPremium
              ? 'flex flex-col items-center justify-center p-6 border border-gray-300 rounded-lg text-center hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 space-y-2'
              : 'flex flex-col items-center justify-center p-6 border rounded-lg text-center bg-gray-100 text-gray-400 cursor-not-allowed space-y-2'
          }
          title={isPremium ? 'Link investments' : 'Premium only'}
        >
          <img 
            src="/icon-link-lrg.png" 
            alt="Link" 
            className="h-8 w-8"
            style={isPremium ? undefined : { filter: 'brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)' }}
          />
          <span className={isPremium ? 'font-medium text-gray-700' : 'font-medium'}>
            Link investments
          </span>
          {!isPremium && <span className="text-xs">Premium only</span>}
        </button>
      </div>
    </div>
  );
};

export default AddAccountType; 
